import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { Form, InputGroup } from "react-bootstrap";

import Editor from "./Editor";
import RequiredLabel from "../../CustomCommons/RequiredLabel";
import { BASE_URL } from "../../Const/Url";
import { showToast } from "../../../utils/ToastHelper";
import { logout_func2 } from "../../Const/logoutCommon";
import { indexingStatus as indexingStatusOptions } from "../../CustomCommons/status";

const CreateBlog = () => {
  const history = useHistory();

  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [heading, setHeading] = useState("");
  const [subHeading, setSubHeading] = useState("");
  const [content, setContent] = useState("");
  const [primaryKeyword, setPrimaryKeyword] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");
  const [indexingStatus, setIndexingStatus] = useState("index");
  const [author, setAuthor] = useState("");
  const [setSchema, setSetSchema] = useState("");

  const [status, setStatus] = useState("published");
  const [visibility, setVisibility] = useState("public");

  const [bannerId, setBannerId] = useState(null);
  const [bannerName, setBannerName] = useState("");
  const [bannerPreview, setBannerPreview] = useState("");
  const [bannerImageAlt, setBannerImageAlt] = useState("");

  const [featuredImageId, setFeaturedImageId] = useState(null);
  const [featuredImageName, setFeaturedImageName] = useState("");
  const [featuredImagePreview, setFeaturedImagePreview] = useState("");
  const [featuredImageAlt, setFeaturedImageAlt] = useState("");

  const [socialImageId, setSocialImageId] = useState(null);
  const [socialImageName, setSocialImageName] = useState("");
  const [socialImagePreview, setSocialImagePreview] = useState("");
  const [socialImageAlt, setSocialImageAlt] = useState("");

  const [categoryQuery, setCategoryQuery] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [tagQuery, setTagQuery] = useState("");
  const [tagOptions, setTagOptions] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [, setOnlogoutHide] = useState(0);

  const uploadDocument = (file, onSuccess) => {
    if (!file) return;
    const formData = new FormData();
    formData.append("document", file);
    formData.append("doc_type", 0);

    axios
      .post(`${BASE_URL}api/v1/auth/documents/upload/`, formData)
      .then((res) => {
        if (res?.data?.status) {
          onSuccess(res?.data?.data?.id);
          showToast("success", "File uploaded successfully");
        } else {
          showToast("error", "Failed to upload file");
        }
      })
      .catch((err) => {
        const message =
          err?.response?.data?.errors?.document?.[0] ||
          err?.response?.data?.message ||
          "Upload failed";
        showToast("error", message);
      });
  };

  const handleBannerUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    uploadDocument(file, (id) => {
      setBannerId(id);
      setBannerName(file.name);
      const reader = new FileReader();
      reader.onload = () => setBannerPreview(reader.result);
      reader.readAsDataURL(file);
    });
  };

  const handleFeaturedImageUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    uploadDocument(file, (id) => {
      setFeaturedImageId(id);
      setFeaturedImageName(file.name);
      const reader = new FileReader();
      reader.onload = () => setFeaturedImagePreview(reader.result);
      reader.readAsDataURL(file);
    });
  };

  const handleSocialImageUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    uploadDocument(file, (id) => {
      setSocialImageId(id);
      setSocialImageName(file.name);
      const reader = new FileReader();
      reader.onload = () => setSocialImagePreview(reader.result);
      reader.readAsDataURL(file);
    });
  };

  const getCategories = (query = "") => {
    const params = new URLSearchParams();
    params.append("limit", 20);
    if (query) {
      params.append("query", query);
    }

    axios
      .get(
        `${BASE_URL}api/v1/frontend/admin/v2/blog-categories/?${params.toString()}`
      )
      .then((res) => {
        const results = res?.data?.data?.results || [];
        const formatted = results.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
        setCategoryOptions(formatted);
      })
      .catch(() => {});
  };

  const getTags = (query = "") => {
    const params = new URLSearchParams();
    params.append("limit", 20);
    if (query) {
      params.append("query", query);
    }

    axios
      .get(
        `${BASE_URL}api/v1/frontend/admin/v2/blog-tags/?${params.toString()}`
      )
      .then((res) => {
        const results = res?.data?.data?.results || [];
        const formatted = results.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
        setTagOptions(formatted);
      })
      .catch(() => {});
  };

  useEffect(() => {
    const debounce = setTimeout(() => {
      getCategories(categoryQuery);
    }, 300);
    return () => clearTimeout(debounce);
  }, [categoryQuery]);

  useEffect(() => {
    const debounce = setTimeout(() => {
      getTags(tagQuery);
    }, 300);
    return () => clearTimeout(debounce);
  }, [tagQuery]);

  const validateForm = () => {
    if (!title.trim()) {
      showToast("error", "Title is required.");
      return false;
    }
    // if (!heading.trim()) {
    //   showToast("error", "Heading is required.");
    //   return false;
    // }
    if (!content || !content.trim()) {
      showToast("error", "Content is required.");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;

    const trimmedSlug = slug.trim();
    const payload = {
      title: title.trim(),
      slug: trimmedSlug,
      is_custom_slug: trimmedSlug.length > 0 ? true : false,
      heading: heading.trim() ? heading.trim() : "",
      sub_heading: subHeading.trim() ? subHeading.trim() : "",
      content: content,
      primary_keyword: primaryKeyword.trim(),
      meta_title: metaTitle.trim(),
      meta_description: metaDescription.trim(),
      canonical_url: canonicalUrl.trim(),
      indexing: indexingStatus,
      author: author.trim(),
      set_schema: setSchema.trim(),
      status,
      visibility,
      banner: bannerId,
      banner_alt_image: bannerImageAlt.trim(),
      featured_image: featuredImageId,
      featured_image_alt: featuredImageAlt.trim(),
      social_image: socialImageId,
      social_image_alt: socialImageAlt.trim(),
      categories: selectedCategories.map((item) => item.value),
      tags: selectedTags.map((item) => item.value),
    };

    setIsSubmitting(true);
    axios
      .post(`${BASE_URL}api/v1/frontend/admin/v2/blogs/`, payload)
      .then(() => {
        showToast("success", "Blog created successfully.");
        history.push("/website-settings/blog-list");
      })
      .catch((err) => {
        const statusCode = err?.response?.status;
        if (statusCode === 401) {
          logout_func2(setOnlogoutHide, history);
          return;
        }
        const message =
          err?.response?.data?.errors?.non_field_errors?.[0] ||
          err?.response?.data?.message ||
          "Failed to create blog. Please try again.";
        showToast("error", message);
      })
      .finally(() => setIsSubmitting(false));
  };

  const handleCancel = () => {
    history.push("/website-settings/blog-list");
  };

  return (
    <div className="categorey-parent new-categorey-parent an">
      <div className="bg-white add-div">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ padding: "20px 35px", border: "0.5px solid #E0E0E0" }}
        >
          <h3 style={{ fontSize: "23px", marginTop: "6px" }}>Create Blog</h3>
        </div>
        <div
          style={{
            padding: "20px 35px",
            borderBottom: "0.5px solid #E0E0E0",
            borderRight: "0.5px solid #E0E0E0",
            borderLeft: "0.5px solid #E0E0E0",
          }}
        >
          <div className="row">
            <div className="col-12 col-md-6">
              <RequiredLabel text="Title" />
              <InputGroup className="mb-3" style={{ height: "47px" }}>
                <Form.Control
                  aria-label="Title"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="Slug (Optional)" />
              <InputGroup className="mb-3" style={{ height: "47px" }}>
                <Form.Control
                  aria-label="Slug"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={slug}
                  onChange={(e) => setSlug(e.target.value)}
                  placeholder="blog-post-url-slug"
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6 " style={{ display: "none" }}>
              <RequiredLabel text="Heading" />
              <InputGroup className="mb-3" style={{ height: "47px" }}>
                <Form.Control
                  aria-label="Heading"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={heading}
                  onChange={(e) => setHeading(e.target.value)}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6 hidden" style={{ display: "none" }}>
              <RequiredLabel text="Sub Heading (Optional)" />
              <InputGroup className="mb-3" style={{ height: "47px" }}>
                <Form.Control
                  aria-label="Sub Heading"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={subHeading}
                  onChange={(e) => setSubHeading(e.target.value)}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="Primary Keyword (Optional)" />
              <InputGroup className="mb-3" style={{ height: "47px" }}>
                <Form.Control
                  aria-label="Primary Keyword"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={primaryKeyword}
                  onChange={(e) => setPrimaryKeyword(e.target.value)}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="Meta Title (Optional)" />
              <InputGroup className="mb-3" style={{ height: "47px" }}>
                <Form.Control
                  aria-label="Meta Title"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={metaTitle}
                  onChange={(e) => setMetaTitle(e.target.value)}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="Meta Description (Optional)" />
              <InputGroup className="mb-3">
                <Form.Control
                  as="textarea"
                  rows={2}
                  aria-label="Meta Description"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={metaDescription}
                  onChange={(e) => setMetaDescription(e.target.value)}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="Canonical URL (Optional)" />
              <InputGroup className="mb-3" style={{ height: "47px" }}>
                <Form.Control
                  aria-label="Canonical URL"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={canonicalUrl}
                  onChange={(e) => setCanonicalUrl(e.target.value)}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="Indexing Status" />
              <Form.Select
                className="mb-3"
                value={indexingStatus}
                onChange={(e) => setIndexingStatus(e.target.value)}
                style={{ height: "47px", backgroundColor: "#FAFAFA" }}
              >
                {indexingStatusOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="Author (Optional)" />
              <InputGroup className="mb-3" style={{ height: "47px" }}>
                <Form.Control
                  aria-label="Author"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={author}
                  onChange={(e) => setAuthor(e.target.value)}
                  placeholder="Enter author name"
                />
              </InputGroup>
            </div>

            <div className="col-12 mt-3">
              <RequiredLabel text="Schema (Optional)" />
              <InputGroup className="mb-3">
                <Form.Control
                  as="textarea"
                  rows={4}
                  aria-label="Schema"
                  style={{ backgroundColor: "#FAFAFA" }}
                  value={setSchema}
                  onChange={(e) => setSetSchema(e.target.value)}
                  placeholder="Enter JSON-LD schema markup"
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6">
              <RequiredLabel text="Status" />
              <Form.Select
                className="mb-3"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                style={{ height: "47px", backgroundColor: "#FAFAFA" }}
              >
                <option value="published">Published</option>
                <option value="pending">Pending Review</option>
                <option value="draft">Drafted</option>
              </Form.Select>
            </div>

            <div className="col-12 col-md-3 hidden" style={{ display: "none" }}>
              <RequiredLabel text="Visibility" />
              <Form.Select
                className="mb-3"
                value={visibility}
                onChange={(e) => setVisibility(e.target.value)}
                style={{ height: "47px", backgroundColor: "#FAFAFA" }}
              >
                <option value="public">Public</option>
                <option value="password">Password Protected</option>
                <option value="private">Private</option>
              </Form.Select>
            </div>

            <div className="col-12 mt-3">
              <RequiredLabel text="Content" />
              <Editor content={content} setContent={setContent} />
            </div>

            <div className="col-12 col-md-6 mt-3">
              <RequiredLabel text="Categories" />
              <Select
                isMulti
                placeholder="Select categories"
                value={selectedCategories}
                onChange={(value) => setSelectedCategories(value || [])}
                onInputChange={(value) => setCategoryQuery(value)}
                options={categoryOptions}
              />
            </div>

            <div className="col-12 col-md-6 mt-3">
              <RequiredLabel text="Tags" />
              <Select
                isMulti
                placeholder="Select tags"
                value={selectedTags}
                onChange={(value) => setSelectedTags(value || [])}
                onInputChange={(value) => setTagQuery(value)}
                options={tagOptions}
              />
            </div>

            <div className="col-12 col-md-4 mt-4">
              <RequiredLabel text="Banner Image (Optional)" />
              <div
                className="w-100 browse-main d-flex align-items-center"
                style={{
                  height: "55px",
                  border: "1px solid #E0E0E0",
                  borderRadius: "7px",
                  overflowX: "hidden",
                }}
              >
                <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                  {bannerName ? "File Chosen" : "No File Chosen"}
                </p>
                <div className="file-up">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleBannerUpload}
                  />
                  <p>Browse</p>
                </div>
              </div>
              {bannerPreview && (
                <div className="my-2">
                  <img
                    height={90}
                    width={90}
                    src={bannerPreview}
                    alt="banner"
                  />
                </div>
              )}
              <div className="mt-2">
                <RequiredLabel text="Banner Image Alt Text (Optional)" />
                <InputGroup className="mb-3" style={{ height: "47px" }}>
                  <Form.Control
                    aria-label="Banner Image Alt Text"
                    style={{ backgroundColor: "#FAFAFA" }}
                    value={bannerImageAlt}
                    onChange={(e) => setBannerImageAlt(e.target.value)}
                    placeholder="Enter alt text for banner image"
                  />
                </InputGroup>
              </div>
            </div>

            <div className="col-12 col-md-4 mt-4">
              <RequiredLabel text="Featured Image (Optional)" />
              <div
                className="w-100 browse-main d-flex align-items-center"
                style={{
                  height: "55px",
                  border: "1px solid #E0E0E0",
                  borderRadius: "7px",
                  overflowX: "hidden",
                }}
              >
                <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                  {featuredImageName ? "File Chosen" : "No File Chosen"}
                </p>
                <div className="file-up">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFeaturedImageUpload}
                  />
                  <p>Browse</p>
                </div>
              </div>
              {featuredImagePreview && (
                <div className="my-2">
                  <img
                    height={90}
                    width={90}
                    src={featuredImagePreview}
                    alt="featured"
                  />
                </div>
              )}
              <div className="mt-2">
                <RequiredLabel text="Featured Image Alt Text (Optional)" />
                <InputGroup className="mb-3" style={{ height: "47px" }}>
                  <Form.Control
                    aria-label="Featured Image Alt Text"
                    style={{ backgroundColor: "#FAFAFA" }}
                    value={featuredImageAlt}
                    onChange={(e) => setFeaturedImageAlt(e.target.value)}
                    placeholder="Enter alt text for featured image"
                  />
                </InputGroup>
              </div>
            </div>

            <div className="col-12 col-md-4 mt-4">
              <RequiredLabel text="Social Image (Optional)" />
              <div
                className="w-100 browse-main d-flex align-items-center"
                style={{
                  height: "55px",
                  border: "1px solid #E0E0E0",
                  borderRadius: "7px",
                  overflowX: "hidden",
                }}
              >
                <p className="my-2 ms-2" style={{ color: "#4F4F4F" }}>
                  {socialImageName ? "File Chosen" : "No File Chosen"}
                </p>
                <div className="file-up">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleSocialImageUpload}
                  />
                  <p>Browse</p>
                </div>
              </div>
              {socialImagePreview && (
                <div className="my-2">
                  <img
                    height={90}
                    width={90}
                    src={socialImagePreview}
                    alt="social"
                  />
                </div>
              )}
              <div className="mt-2">
                <RequiredLabel text="Social Image Alt Text (Optional)" />
                <InputGroup className="mb-3" style={{ height: "47px" }}>
                  <Form.Control
                    aria-label="Social Image Alt Text"
                    style={{ backgroundColor: "#FAFAFA" }}
                    value={socialImageAlt}
                    onChange={(e) => setSocialImageAlt(e.target.value)}
                    placeholder="Enter alt text for social image"
                  />
                </InputGroup>
              </div>
            </div>

            <div className="mt-4">
              <button
                onClick={handleSubmit}
                className="save-btn me-2 mt-2"
                style={{ background: "#000", color: "white" }}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save"}
              </button>
              <button
                onClick={handleCancel}
                className="save-btn mt-2"
                style={{ border: ".4px solid #E0E0E0 !important" }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateBlog;
